import { retornoHashValor } from '../../modulos/cripotografia/hash';
import apiZelo from '../backAxiosVendaToken';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const BuscarEntregues = async cod => {
    await fetch(`${url}/associados-vendedor/entregues/${cod}`, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson.length > 0) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};

export const BuscarAtrasados = async cod => {
    try {
        const response = await apiZelo.get(
            `/associados-vendedor/atrasados/${cod}`
        );

        if (response.data['relatorio']) {
            return response.data.relatorio;
        } else {
            return { erro: 'parametros errados' };
        }
    } catch (error) {
        return error.message;
    }
};

export const Buscar = async (cod, perm, query) => {
    const baseUrl = '/associados-perfis/lista';
    const url = query ? `${baseUrl}/${cod}/${perm}?${query}` : `${baseUrl}/${cod}/${perm}`;

    await apiZelo
        .get(url)
        .then(response => {
            if (response.data.length > 0) {
                const data = response.data;

                for (const i in data) {
                    if (data[i].Inscricaos[0] === undefined) {
                        data[i].Inscricaos[0] = { Pagamento: null };
                    }
                }

                retorno = response.data;
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};

export const buscarPorInscricao = async (cod, perm, inscricao) => {
    try {
        const baseUrl = '/associados-perfis/unico';
        const url = `${baseUrl}/${cod}/${perm}?inscricao=${inscricao}`;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

export const buscarContratoPorDados = async (cod, perm, dadosBusca) => {
    try {
        const baseUrl = '/associados-perfis/unico';
        const url = `${baseUrl}/${cod}/${perm}?nome=${dadosBusca}`;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

export const buscarContratoPorDadosCpf = async (cod, perm, dadosBusca) => {
    try {
        const baseUrl = '/associados-perfis/unico';
        const url = `${baseUrl}/${cod}/${perm}?cpf=${dadosBusca}`;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

//Rota chamando pela Sensedia armazenada até a liberação do EndPoint
export const BuscarData = async (cod, data, permissao) => {
    try {
        const response = await apiZelo.get(
            `/associados-perfis/lista/${cod}/${permissao}?data=${data}`
        );

        if (response && response.data && !response.data.length) { return new Error('Not Found'); }

        return response.data;
    } catch (err) {
        return new Error(err);
    }
};

export const Atualizar = async cod => {
    await fetch(`${url}/vendedor/${cod.cod}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        body: JSON.stringify(cod)
    })
        .then(response => {
            retorno = response;
        })
        .catch(err => { });

    return retorno;
};

export const Aniversario = async cod => {
    await fetch(`${url}/aniversario-associado/${cod}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => { });

    return retorno;
};

export const enviarEmail = async inscricao => {
    await fetch(`${url}/enviarEmail/pdf-resource/email-contrato/${inscricao}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }

    }).then(resp => {
        retorno = resp;
    });

    return retorno;
};

export const vendedorVendas = async codigo => {
    try {
        const response = await apiZelo.post(`/associados-vendedor/vendasTotal/${codigo}`);

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const vendasStatus = async codigo => {
    try {
        const response = await apiZelo.post(`/associados-vendedor/vendasPorStatus/${codigo} `);

        return response;
    } catch (error) {
        return error.message;
    }
};

export const supervisorVendas = async supp => {
    await fetch(`${url}/supervisor/graficoSupervisor/${supp}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const supervisorVendasOnly = async supp => {
    await fetch(`${url}/supervisor/graficoSupervisorName/${supp}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const coordenadorVendas = async supp => {
    await fetch(`${url}/coordenador/graficoCoordenador/${supp}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const coordenadorVendasOnly = async supp => {
    await fetch(`${url}/coordenador/graficoCoordenadorNome/${supp}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const coordenadorVendasOnlySupervisores = async supp => {
    await fetch(`${url}/coordenador/graficoCoordenadorNomeTotal/${supp}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const insereMensalidade = async inscricao => {
    try {
        const response = await apiZelo.post('/mensalidades/geraMensalidades', { inscricao });

        return response;
    } catch (error) {
        return error.message;
    }
};

export const atualizaMensalidade = async inscricao => {
    try {
        const response = await apiZelo.put('/mensalidades/atualiza-mensalidades', { inscricao });

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarMensalidade = async cod => {
    await fetch(`${url}/associados-vendedor/entregues/${cod}`, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson.length > 0) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};

export const graficoGerentes = async ger => {
    await fetch(`${url}/gerente/graficos-gerente-total-vendedor/${ger}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};
